export default __webpack_public_path__ + "static/media/Aeonik-Regular.598a6cbd.woff";